/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { DomainItemDTO } from '@api/models/.';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'domainFilter',
  standalone: false
})
export class DomainFilterPipe implements PipeTransform {
  private readonly searchTextMinLength = 3;

  transform(
    list: DomainItemDTO[],
    searchText: string,
    maxResults?: number
  ): DomainItemDTO[] {
    if (!list) {
      return [];
    }

    maxResults = typeof maxResults === 'number' ? maxResults : Infinity;

    if (!this.isSearchTextAcceptable(searchText)) {
      return list.slice(0, maxResults);
    }

    searchText = searchText.toLowerCase();

    return list
      .filter(item => this.doesItemMatchFilter(item, searchText))
      .slice(0, maxResults);
  }

  private isSearchTextAcceptable(searchText: string): boolean {
    return (
      typeof searchText === 'string' &&
      searchText.length >= this.searchTextMinLength
    );
  }

  private doesItemMatchFilter(
    item: DomainItemDTO,
    searchText: string
  ): boolean {
    const value = item.value.toLowerCase();
    const key = item.key.toLowerCase();

    return (
      value.toLowerCase().includes(searchText) ||
      key.toLowerCase() === searchText
    );
  }
}
